import { ProfileSettingsForm } from '@/components/auth/ProfileSettingsForm';

export function ProfileSettings() {
  return <ProfileSettingsForm />;
}
